const API_BASE_URL = "https://hype-circle-app-cloud-913961422896.europe-west1.run.app/api";
const API_KEY = process.env.REACT_APP_MONGO_API_KEY;

class MongoAdminAPI {
  constructor() {
    if (!API_KEY || API_KEY === 'your-mongo-api-key-here') {
      console.warn('MongoDB API key not configured. Please set REACT_APP_MONGO_API_KEY in .env file');
    }
    
    this.headers = {
      'Content-Type': 'application/json',
      'X-API-Key': API_KEY || 'missing-api-key'
    };
  }

  // Movies Admin APIs
  async createMovie(movieData) {
    const response = await fetch(`${API_BASE_URL}/movies/`, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(movieData)
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return data;
  }

  async updateMovie(movieId, movieData) {
    if (!movieId) {
      throw new Error('Movie ID is required for update');
    }
    
    const response = await fetch(`${API_BASE_URL}/movies/${movieId}`, {
      method: 'PUT',
      headers: this.headers,
      body: JSON.stringify(movieData)
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return data;
  }

  async updateMovieByTmdbId(tmdbId, movieData) {
    if (!tmdbId) {
      throw new Error('TMDB ID is required for update');
    }
    
    const response = await fetch(`${API_BASE_URL}/movies/tmdb/${tmdbId}`, {
      method: 'PUT',
      headers: this.headers,
      body: JSON.stringify(movieData)
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return data;
  }

  async deleteMovie(movieId) {
    if (!movieId) {
      throw new Error('Movie ID is required for deletion');
    }
    
    const response = await fetch(`${API_BASE_URL}/movies/${movieId}`, {
      method: 'DELETE',
      headers: this.headers
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}: ${response.statusText}`);
    }
    
    return data;
  }

  async bulkCreateMovies(moviesArray) {
    const response = await fetch(`${API_BASE_URL}/movies-enhanced/bulk`, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify({ movies: moviesArray })
    });
    return response.json();
  }

  async findDuplicateMovies() {
    const response = await fetch(`${API_BASE_URL}/movies-enhanced/duplicates`, {
      headers: this.headers
    });
    return response.json();
  }

  async getMovieStats() {
    const response = await fetch(`${API_BASE_URL}/movies/stats`);
    return response.json();
  }

  async getMovieFilters() {
    const response = await fetch(`${API_BASE_URL}/movies/filters`);
    return response.json();
  }

  async getTrendingMovies() {
    const response = await fetch(`${API_BASE_URL}/movies-enhanced/trending`);
    return response.json();
  }

  async getMovieReleases(period = 'this_week') {
    const response = await fetch(`${API_BASE_URL}/movies-enhanced/releases?period=${period}`);
    return response.json();
  }

  async getSimilarMovies(movieId) {
    const response = await fetch(`${API_BASE_URL}/movies-enhanced/${movieId}/similar`);
    return response.json();
  }

  // Shows Admin APIs
  async createShow(showData) {
    const response = await fetch(`${API_BASE_URL}/shows/`, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(showData)
    });
    return response.json();
  }

  async updateShow(showId, showData) {
    const response = await fetch(`${API_BASE_URL}/shows/${showId}`, {
      method: 'PUT',
      headers: this.headers,
      body: JSON.stringify(showData)
    });
    return response.json();
  }

  async deleteShow(showId) {
    const response = await fetch(`${API_BASE_URL}/shows/${showId}`, {
      method: 'DELETE',
      headers: this.headers
    });
    return response.json();
  }

  async getShowStats() {
    const response = await fetch(`${API_BASE_URL}/shows/stats`);
    return response.json();
  }

  async getShowFilters() {
    const response = await fetch(`${API_BASE_URL}/shows/filters`);
    return response.json();
  }

  // Generic search
  async searchContent(query, type = 'movies') {
    const response = await fetch(`${API_BASE_URL}/${type}?search=${encodeURIComponent(query)}`);
    return response.json();
  }
}

export const mongoAdminApi = new MongoAdminAPI();